import React, { useState } from 'react';
import '../styles/formStyles.css';
import LoaderOverlay from './LoaderOverlay';
import { showAppAlert } from '../utils/alertService';

const API_URL = process.env.REACT_APP_API_BASE_URL;
function RequestResgateModal({ client, promo, visible, onClose, onResgateCompleted }) {
  const token = localStorage.getItem('token');
  const [loading, setLoading] = useState(false);

  if (!visible || !promo) {
    return null;
  }

  const handleOk = async () => {
    if (client.saldo_pontos < promo.pontos) {
      showAppAlert('error', 'O cliente não possui pontos suficientes para este resgate.');
      return;
    }
    
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/redeem-points/${client.id}/${promo.id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        showAppAlert('success', 'Resgate realizado com sucesso!');
        setTimeout(() => {
          onClose();
          onResgateCompleted(client.id, promo.pontos);
          setLoading(false);
        }, 2000);
      } else {
        const errorData = await response.json();
        showAppAlert('error', `Erro ao solicitar resgate: ${errorData.message}`);
        setLoading(false);
      }
    } catch (error) {
      showAppAlert('error', `Erro ao solicitar resgate: ${error.message}`);
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <LoaderOverlay isLoading={loading} message="Processando resgate..." />
      <div className="modal-content small-modal" style={{ textAlign: 'center' }}>
        <h3 className="form-title">Confirmar Resgate</h3>
        <p>Cliente: <strong>{client.nome}</strong></p>
        <p>Saldo Atual: <strong>{Number(client.saldo_pontos).toFixed(1)} pontos</strong></p>
        <hr style={{ margin: '15px 0' }} />
        <p>Deseja resgatar a promoção:</p>
        <p><strong>"{promo.nome}"</strong></p>
        <p>por <strong>{promo.pontos} pontos</strong>?</p>
        <div style={{ marginTop: '15px' }}>
          <button onClick={handleOk} className="button-style" disabled={loading}>
            {loading ? 'Resgatando...' : 'OK'}
          </button>
          <button onClick={onClose} className="button-style cancel" style={{ marginLeft: '10px' }} disabled={loading}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default RequestResgateModal;
